import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';

import { smoothScroll as handleLinkClick } from 'utils/domUtils';
import OpenFormSection from 'patterns/OpenFormSection/OpenFormSection';
import ShortForm from 'patterns/ShortForm/ShortForm';
import useOpenFormVisibility from 'utils/hooks/useOpenFormVisibility/useOpenFormVisibility';

import { StyledBox } from './styles/Box';

function SectionForm({ onFormVisibilityChange }) {
  const [ref, isFormHidden] = useOpenFormVisibility();

  useEffect(() => {
    onFormVisibilityChange(isFormHidden);
  }, [isFormHidden]);

  return (
    <OpenFormSection ref={ref}>
      <StyledBox
        display="flex"
        minHeight={{ md: 'calc(100vh - 4rem)', lg: 'calc(100vh - 8rem)' }}
        paddingVertical={{ xs: '12x' }}
        paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }}
      >
        <Grid row spacing={0} alignItems={{ lg: 'center' }}>
          <Grid col={{
            xs: 12,
            md: 8,
            lg: 4,
            xl: 3,
          }}
          >
            <Box
              minHeight={{ xs: 'calc(100vh - 14rem)', md: 'auto' }}
              display="flex"
              flexDirection="column"
              justifyContent="flex-end"
            >
              <Typography
                variant="title"
                color="white"
                colorVariant="dark"
                intlKey="FGTS.OPEN_FORM.HEADLINE"
                gutterBottom={1.5}
              />
              <Typography
                variant="subtitle"
                color="white"
                colorVariant="dark"
                intlKey="FGTS.OPEN_FORM.DESCRIPTION"
                gutterBottom={1.5}
              />
              <Link
                onClick={handleLinkClick}
                variant="action"
                href="#beneficios"
                color="white"
                colorVariant="dark"
                iconProps={{ name: 'arrow-down' }}
                intlKey="FGTS.OPEN_FORM.ANCHOR.TITLE"
              />
            </Box>
          </Grid>
          <Grid col={{ xs: 12, md: 6, lg: 3 }} offset={{ md: 6, lg: 5, xl: 6 }}>
            <Box
              display="flex"
              justifyContent={{ md: 'flex-end' }}
              alignItems={{ md: 'flex-end' }}
              height={{ md: '100%' }}
            >
              <ShortForm />
            </Box>
          </Grid>
        </Grid>
      </StyledBox>
    </OpenFormSection>
  );
}

SectionForm.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default React.memo(SectionForm);
